import { oc } from '@orpc/contract';
import { changePasswordInputSchema, tokensOutputSchema } from '../schemas/auth.schemas.js';
export const changePasswordContract = oc
    .route({
    method: 'POST',
    path: '/auth/change-password',
    tags: ['Auth'],
    summary: 'Change the signed-in user’s password; signs out every other device and returns a fresh token pair',
})
    .input(changePasswordInputSchema)
    .output(tokensOutputSchema);
//# sourceMappingURL=change-password.contract.js.map